import { Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import { ArrowLeft, Edit } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import API from "../../API/newIndex";
import { DataLoad } from "../../App";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { formatDate } from "../../controllers/FormatAmount";
import { useLastRoute } from "../../controllers/LastRouteContext";
import MuiSwitch from "../../controllers/MuiSwitch";
import { parentNavigate } from "../../controllers/ParentNavigate";
import {
  ButtonComponent,
  CommonTable
} from "@shopeasy-dashboard-ui/ui-library";
import NoRecords from "../Main/NoRecords";
import Notification from "../Notification";
import AddBlogComments from "./AddBlogComments";
const PerticularBlogComment = () => {
  const params = useParams();
  const [clearRow, setClearRow] = useState(false);
  const { dataLoading, setDataLoading } = useContext(DataLoad);
  const [BlogComments, setBlogComments] = useState();
  const [selectedRowsId, setSelectedRowsId] = useState([]);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const lastRoute = useLastRoute();
  const GetBlogComments = async () => {
    setDataLoading(true);
    try {
      let ApiCall = await API({
        url: `/admin/blog/getparticularBlogcomment/${params?.commentId}`,
        method: "get",
      });
      const result = ApiCall?.data;
      setBlogComments(result);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setDataLoading(false);
    }
  };

  //Disable Blog Comment
  const DisableComment = async (id, value) => {
    try {
      const payload = {
        is_visible: value,
      };
      await API({ url: `/admin/blog/updateBlogcomments/${id}`, method: "put", data: payload });
      GetBlogComments();
      setIsNotification(true);
      setNotificationMsg(value ? "Blog comment is set to active" : "Blog comment is set to hidden");
      setSeverity("success");
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  // Disable Many Blog comments\\
  const UpdateManyComments = async (value) => {
    try {
      const payload = {
        id: selectedRowsId,
        is_visible: value,
      };
      await API({ url: "/admin/blog/UpdateManyBlogComment", method: "put", data: payload });
      setSelectedRowsId([]);
      setClearRow(!clearRow);
      setIsNotification(true);
      setNotificationMsg(`Comments set to ${value ? "active" : "hidden"}`);
      setSeverity("success");
      GetBlogComments();
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };
  const [editCommentData, setEditCommentData] = useState();

  const closeAddComment = (value) => {
    if (value === "call api") {
      GetBlogComments();
      setIsAddComment(false);
    } else {
      setIsAddComment(false);
    }
  };
  useEffect(() => {
    GetBlogComments();
  }, []);
  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };
  const [blogData, setBlogData] = useState();
  useEffect(() => {
    if (BlogComments?.data?.records?.length) {
      setBlogData(BlogComments?.data?.records[0]?.blogId);
    }
  }, [BlogComments]);
  const [isAddComment, setIsAddComment] = useState(false);
  const commentRef = useRef();

  useEffect(() => {
    if (isAddComment) {
      setTimeout(() => {
        commentRef.current?.focus();
      }, 100);
    }
  }, [isAddComment]);

  const handleSelectRow = (id) => {
    if (id === "all") {
      if (selectedRowsId?.length > 0) {
        setSelectedRowsId([]);
      } else {
        setSelectedRowsId(BlogComments?.data?.records?.map((x) => x?._id));
      }
    } else {
      const existId = selectedRowsId?.length > 0 && selectedRowsId?.find((x) => x === id);
      if (!existId) {
        setSelectedRowsId([...selectedRowsId, id]);
      } else {
        const removeSelected = selectedRowsId?.filter((x) => x !== id);
        setSelectedRowsId(removeSelected);
      }
    }
  };
  const columns = [
    {
      key: "checkbox",
      title: (
        <Checkbox
          checked={
            BlogComments?.data?.records?.length > 0 &&
            selectedRowsId?.length === BlogComments?.data?.records?.length
          }
          indeterminate={
            selectedRowsId?.length > 0 &&
            selectedRowsId?.length < BlogComments?.data?.records?.length
          }
          onChange={() => handleSelectRow("all")}
        />
      ),
      align: "text-center",
      ignoreRowClick: true,
      width: "50px",
      minWidth: "50px",
      maxWidth: "50px",
      headerClassName: "!px-0 text-center",
      cellClassName: "!px-0 text-center",
      render: (row) => (
        <Checkbox
          disabled={row?.default}
          checked={selectedRowsId?.length > 0 && selectedRowsId?.includes(row._id)}
          onChange={() => handleSelectRow(row._id)}
        />
      ),
    },
    {
      key: "name",
      title: t("lang_name"),
      minWidth: "150px",
      headerClassName: "px-3 text-left uppercase",
      cellClassName: "px-3 text-left",
      render: (row) => (
        <p
          className={`text-xs font-medium ${row?.channel === "online"
            ? "text-[var(--primary-color)] hover:underline cursor-pointer"
            : "text-[var(--primary-text-color)]"
            }`}
          onClick={() => {
            if (row?.channel === "online") {
              parentNavigate(`/customers/${row?.user?._id}`);
            }
          }}
        >
          {row?.name || "-"}
        </p>
      ),
    },
    {
      key: "email",
      title: t("lang_email"),
      minWidth: "180px",
      headerClassName: "px-3 text-left uppercase",
      cellClassName: "px-3 text-left",
      render: (row) => (
        <p className="text-xs text-[var(--table-text-color)]">{row?.email || "-"}</p>
      ),
    },
    {
      key: "comment",
      title: t("lang_comment"),
      minWidth: "200px",
      headerClassName: "px-3 text-left uppercase",
      cellClassName: "px-3 text-left",
      render: (row) => (
        <p className="line-clamp-1 text-xs text-[var(--primary-text-color)]">
          {row?.comment ? row.comment : "-"}
        </p>
      ),
    },
    {
      key: "date",
      title: t("lang_date"),
      width: "120px",
      minWidth: "120px",
      maxWidth: "120px",
      headerClassName: "px-3 text-right uppercase",
      cellClassName: "px-3 text-right",
      align: "text-right",
      render: (row) => (
        <span className="text-xs text-[var(--table-text-color)]">
          {formatDate(row?.createdAt)}
        </span>
      ),
    },
    {
      key: "active",
      title: t("lang_active"),
      width: "100px",
      minWidth: "100px",
      maxWidth: "100px",
      headerClassName: "px-3 text-right uppercase",
      cellClassName: "px-3 text-right",
      align: "text-right",
      ignoreRowClick: true,
      render: (row) => (
        <label className="relative flex justify-end w-full">
          <FormControlLabel
            checked={row?.is_visible}
            control={<MuiSwitch />}
            onChange={() => DisableComment(row._id, !row?.is_visible)}
          />
        </label>
      ),
    },
    {
      key: "action",
      title: t("lang_action"),
      width: "80px",
      minWidth: "80px",
      maxWidth: "80px",
      headerClassName: "px-3 text-right uppercase",
      cellClassName: "px-3 text-right",
      align: "text-right",
      ignoreRowClick: true,
      render: (row) => (
        <div className="flex items-center justify-end w-full space-x-2.5">
          <Tooltip title="Edit" arrow>
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsAddComment(true);
                setEditCommentData(row);
              }}
            >
              <Edit className="h-4 w-4 text-[var(--table-text-color)] hover:text-[var(--primary-text-color)] transition-colors" />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const tableHeader = (
    <div className="relative w-full border-b main-border-color secondary-bg-color px-3 py-2 flex flex-wrap items-center justify-between gap-2 min-h-[50px]">
      <h6 className="font-medium text-base line-clamp-1 m-0">
        {BlogComments?.data?.blog?.title}
      </h6>
      {selectedRowsId && selectedRowsId?.length > 0 && (
        <div className="flex items-center gap-1">
          <span className="text-sm px-2 whitespace-nowrap">
            {selectedRowsId?.length} {t("lang_selected")}
          </span>
          <span className="me-1">|</span>
          <ButtonComponent
            variant="outline"
            size="sm"
            className="mx-1"
            onClick={() => UpdateManyComments(false)}
          >
            {t("lang_Hide_Comments")}
          </ButtonComponent>
          <ButtonComponent
            variant="outline"
            size="sm"
            className="mx-1"
            onClick={() => UpdateManyComments(true)}
          >
            {t("lang_Show_Comments")}
          </ButtonComponent>
        </div>
      )}
    </div>
  );

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto overflow-x-hidden pb-[64px] p-5">
        <div className="flex flex-wrap items-end justify-between w-full page-header-pb">
          <div className="flex items-center space-x-2">
            <button
              onClick={(e) => {
                e.preventDefault();
                parentNavigate(lastRoute ? lastRoute : "/blog/comments");
              }}
              className="back-arrow -ml-3.5"
            >
              <ArrowLeft />
            </button>
            <div>
              <Breadcrumbs
                crumbs={[
                  { name: t("lang_dashboard"), path: `/dashboard` },
                  { name: t("lang_Blog_Comments"), path: "/blog/comments" },
                  { name: t("lang_Particular_Comment") || "Particular Comment" },
                ]}
              />
              <h4 className="text-xl md:text-2xl font-semibold text-primary">
                {t("lang_Particular_Comment") || "Particular Comment"}
              </h4>
            </div>
          </div>
        </div>

        <div className="w-full space-y-3">
          <CommonTable
            columns={columns}
            data={BlogComments?.data?.records}
            tableHeader={tableHeader}
            loading={dataLoading}
            emptyMessage={<NoRecords />}
            rowClassName={(row) =>
              `select-none ${selectedRowsId?.find((x) => x === row?._id) ? "selected-row" : ""}`
            }
          />

          <Link
            onClick={(e) => {
              e.preventDefault();
              parentNavigate("/blog/comments");
            }}
            className="w-fit flex text-link font-medium hover:underline text-sm items-center pt-2"
          >
            <ArrowLeft className="w-3 mr-1" />
            {t("lang_Go_To_All_Blog_Comments")}
          </Link>
        </div>
      </div>
      <AddBlogComments
        commentRef={commentRef}
        isAddComment={isAddComment}
        closeAddComment={closeAddComment}
        editCommentData={editCommentData}
        type="edit"
      />
    </>
  );
};

export default PerticularBlogComment;
